import { BaseRollerProductType } from '../constants/productTypes';
import { ProductBuilderMachineContext } from '../types';

export const isRollerEssentials = ({
  products,
}: ProductBuilderMachineContext) => {
  const rollerDayNightChainBaseProductType: BaseRollerProductType =
    'Roller Blind Essentials Chain';
  const location = window.location.pathname.includes('roller-blind-essentials');
  return (
    products[0].type.includes(rollerDayNightChainBaseProductType) && location
  );
};
